import {
  removeFolder,
  renameFolder,
  updateFolders,
  addFolder,
  updateProtocolFolder,
  updateFolderParentId} from './protocol.slice';
import { TThunkDispatch } from '../hooks';
import {
  deleteFolder,
  getFolders,
  postFolder,
  postFolderName,
  postFolderParent,
  postProtocolFolder } from "../../http/protocolFolder";


export const retrieveFoldersAsync = () => async(dispatch: TThunkDispatch) =>
{
  const folders = await getFolders();
  if(!folders)
  {
    console.log("No data returned from getFolders");
    return;
  }

  return dispatch(updateFolders(folders)).payload;
};

export const createFolderAsync = (name: string, parentFolderId?: number) => async(dispatch: TThunkDispatch) =>
{
  const folderId = await postFolder(name, parentFolderId);
  if(!folderId)
    return;

  return dispatch(addFolder({ folderId, parentFolderId, name })).payload;
};

export const updateProtocolFolderAsync = (protocolId: number, folderId?: number) => async(
  dispatch: TThunkDispatch) =>
{
  dispatch(updateProtocolFolder({ protocolId, folderId: folderId || undefined }));

  return postProtocolFolder(protocolId, folderId);
};

export const updateFolderParentAsync = (folderId: number, parentFolderId?: number) => async(
  dispatch: TThunkDispatch) =>
{
  dispatch(updateFolderParentId({ folderId, parentFolderId: parentFolderId || undefined }));

  return postFolderParent(folderId, parentFolderId);
};

export const renameFolderAsync = (folderId: number, name: string) => async(dispatch: TThunkDispatch) =>
{
  dispatch(renameFolder({ folderId, name }));

  return postFolderName(folderId, name);
};

export const deleteFolderAsync = (folderId: number) => async(dispatch: TThunkDispatch) =>
{
  dispatch(removeFolder(folderId));

  return deleteFolder(folderId);
};